import {fetchGet} from "../../requests/NetworkRequestAuth0";
import {uri} from "./AppRequest";

export const getUserVenueRewards = (
    venueId,
    userCode,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    fetchGet(
        uri + "/venue/" + venueId + "/user/" + userCode + "/rewards",
        successMethod,
        errorMethod,
        getAccessTokenSilently);
};

export const getUserVenueReward = (
    venueId,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    fetchGet(
        uri + "/user/venue/" + venueId + "/rewards",
        successMethod,
        errorMethod,
        getAccessTokenSilently);
};